
import React from 'react';
interface VimeoProps {
  id: string;
  keyName?: string;
  time?: string;
}

const IframePlayer: React.FC<VimeoProps> = ({ id = '', keyName, time = '0' }) => {
  return (
    <div
      className="video"
      style={{
        position: 'relative',
        paddingBottom: '56.25%' /* 16:9 */,
        background: '#333',
        height: 0,
        width: '100%',
      }}
    >
      <iframe
        key={keyName || `videoPlay${new Date().getTime()}`}
        frameBorder="0"
        allow="autoplay; fullscreen"
        allowFullScreen

        style={{
          position: 'absolute',
          top: 0,
          left: 0,
          width: '100%',
          height: '100%',
        }}
        title={id}
        src={`${id}`}
      />
    </div>
  );
};

export default IframePlayer;
